<template>
  <form class="avatar-form">
    <label class="avatar-input" :class="{'avatar-input_uploaded': uploaded, 'avatar-input_nonehover': !edited}">
      <avatar-icon v-if="!uploaded && !avatarVal"></avatar-icon>
      <input type="file"
             :disabled="!edited"
             :readonly="!edited"
             name="avatar"
             @change="addAvatar"
             accept="image/jpeg, image/x-png,image/gif">
      <div class="input-wrap">

        <img v-if="imgSrc"
             :src="imgSrc"
             class="avatar-img">
      </div>

    </label>
    <errors class="size-error"
            type="fileSize"
            v-if="edited"
            :min-length="'1'"
            :style="{color: sizeError ? '#ED1C24' : '#505D6F', opacity: sizeError ? 1 : 0.4}"></errors>
  </form>
</template>

<script>
  import avatarIcon from '../../Svg/avatarIcon'
  import {createNamespacedHelpers} from 'vuex'
  import errors from '../../Forms/errors'

  const {mapState} = createNamespacedHelpers('profile');
  const {mapMutations} = createNamespacedHelpers('profile');


  export default {
    name: 'profileAvatar',
    props: {
      edited: {
        type: Boolean,
        required: false
      }
    },
    components: {
      avatarIcon,
      errors
    },
    data() {
      return {
        uploaded: false,
        sizeError: false,
      }
    },
    computed: {
      ...mapState([
        'avatar',
        'photoUpload'
      ]),
      avatarVal: {
        get() {
          return this.avatar
        },
        set(val) {
          this.SET_AVATAR(val);
        }
      },
      imgSrc() {
        if (this.avatarVal) {
          return this.avatarVal
        } else if (this.photoUpload) {
          return this.photoUpload
        } else {
          return ''
        }
      }
    },
    methods: {
      ...mapMutations([
        'SET_AVATAR',
        'SET_PHOTO',
        'SET_DIRT'
      ]),
      addAvatar(e) {
        const filesList = e.target.files;
        const thisFile = filesList[filesList.length - 1];
        const imgSize = thisFile.size;
        const cntx = this;
        const maxSizeMB = 1048576;

        if (imgSize < maxSizeMB) {
          if (thisFile != undefined) {
            // console.log(this.$refs.profileAvatar.files[0]);
            this.SET_PHOTO(thisFile);
            //убираем ошибку размера файла
            this.sizeError = false;
            //создаем объект для парсинга в base64
            const reader = new FileReader();
            reader.onload = function (event) {
              //result
              const contents = event.target.result;
              //получаем img и меняем его src
              cntx.SET_AVATAR(contents);
              let img = document.querySelectorAll('.avatar-img');
              for (let i = 0; i < img.length; i++) {
                let image = img[i];
                image.src = contents
              }
              // img.src = contents;
              //сохраняем в vuex
              //cntx.imgLocal = contents;
              cntx.uploaded = true
            };

            reader.readAsDataURL(thisFile);
            this.SET_DIRT(true);
          }
        } else {
          this.sizeError = true;
          setTimeout(() => {
            this.sizeError = false
          }, 3000)
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .avatar-img {
    width: auto;
    height: 100%;
  }
  .avatar-input {
    min-width: 124px;
    min-height: 124px;
    max-width: 124px;
    height: 124px;
    width: 124px;
    max-height: 124px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    outline: none;
    margin-bottom: 20px;

    img {
      //position: absolute;
      width: 100%;
      height: auto;
      left: 0;
      top: 0;
    }

    svg {
      position: absolute;
    }

    &:hover .input-wrap {
      border: 1px solid $lightBlue;
    }

    .input-wrap {
      width: 100%;
      height: 100%;
      border: 1px solid $lightGrey;
      border-radius: 50%;
      transition: $anim;
      overflow: hidden;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    input {
      position: absolute;
      z-index: -999;
      opacity: 0;
      width: 0;
      height: 0;
    }

    input:focus + .input-wrap {
      border: 1px solid $lightBlue;
    }



  }

  .size-error {
    font-family: $mm;
    font-size: 12px;
    letter-spacing: .25px;
    color: $asphalt;
    opacity: .5;
    text-align: center;
    margin-bottom: 20px;
  }

  .avatar-input_nonehover {
    cursor: default;

    &:hover .input-wrap {
      border: 1px solid $lightGrey;

    }

    input:focus + .input-wrap {
      border: 1px solid $lightGrey;
    }
  }
</style>
